class HandlePagination {
	update(options) {
		this.$pagination = options.pagination
		this.totalPages = options.totalPages
		this.currentPage = options.currentPage
		this.numberNextItems = options.numberNextItems
		this.numberPrevItems = options.numberPrevItems
		this._updateMarkup()
	}

	_updateMarkup() {
		let markup = ""
		this.$pagination.find(".bb-pagination__list-item.page").remove()
		for (let i = 0; i <= this.totalPages; i++) {
			markup +=
				'<li class="bb-pagination__list-item page"  data-page="' +
				(i + 1) +
				'"><a class="page-link" href="#">' +
				(i + 1) +
				"</a></li>"
		}
		$(markup).insertAfter(this.$pagination.find(".separator").eq(0))
		this._updatePagination()
	}

	_updatePagination() {
		let $currentPaginationItem = this.$pagination.find(".bb-pagination__list-item.page").eq(this.currentPage - 1)
		let $otherPaginationItems = this.$pagination.find(".bb-pagination__list-item.page").not($currentPaginationItem)
		let $separator = this.$pagination.find(".separator")
		let $prev = this.$pagination.find(".prev")
		let $first = this.$pagination.find(".first")
		let $last = this.$pagination.find(".last")
		let $next = this.$pagination.find(".next")
		let numberPrevItems = this.numberPrevItems
		let numberNextItems = this.numberNextItems
		let distToEnd = this.totalPages - this.currentPage
		let distToBegin = this.currentPage - 1

		$otherPaginationItems.hide().removeClass("active")
		$currentPaginationItem.addClass("active").show()
		$separator.hide()

		if (this.totalPages <= 1) {
			this.$pagination.hide()
		} else {
			this.$pagination.show()
		}

		if (this.currentPage !== 1) {
			$prev.removeClass("disabled")
			$first.removeClass("disabled")
		} else {
			$prev.addClass("disabled")
			$first.addClass("disabled")
		}

		if (this.currentPage !== this.totalPages) {
			$next.removeClass("disabled")
			$last.removeClass("disabled")
		} else {
			$next.addClass("disabled")
			$last.addClass("disabled")
		}

		this.maxPaginationItems = this.numberNextItems + this.numberPrevItems + 1

		if (this.totalPages <= this.maxPaginationItems) {
			this.$pagination.find(".bb-pagination__list-item.page:lt(" + this.totalPages + ")").show()
		} else {
			if (distToBegin < this.numberPrevItems || distToEnd < this.numberNextItems) {
				if (distToBegin < this.numberPrevItems) {
					numberPrevItems = distToBegin
					numberNextItems = this.numberPrevItems + this.numberNextItems - numberPrevItems
				}

				if (distToEnd < this.numberNextItems) {
					numberNextItems = distToEnd
					numberPrevItems = this.numberPrevItems + this.numberNextItems - distToEnd
				}
			}

			if (this.currentPage - this.numberPrevItems > 1) {
				$separator.eq(0).show()
			}
			if (this.currentPage + this.numberNextItems < this.totalPages) {
				$separator.eq(1).show()
			}

			$currentPaginationItem.nextAll(".bb-pagination__list-item.page:lt(" + numberNextItems + ")").show()
			$currentPaginationItem.prevAll(".bb-pagination__list-item.page:lt(" + numberPrevItems + ")").show()
		}

		this.$pagination.find(".pagination-text").text("Seite " + this.currentPage + " von " + this.totalPages)
	}
}

export default new HandlePagination()
